import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=771d4f6b&scoped=true"
import script from "./GenericTable.vue?vue&type=script&lang=js"
export * from "./GenericTable.vue?vue&type=script&lang=js"
import style0 from "./GenericTable.vue?vue&type=style&index=0&id=771d4f6b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771d4f6b",
  null
  
)

export default component.exports